/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "omg": {
        "nested": {
          "cash": {
            "nested": {
              "CashLocalOrderExtension": {
                "fields": {
                  "brandToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "source": {
                    "type": ".squareup.omg.cash.CashLocalOrderExtension.CashLocalSource",
                    "id": 2,
                    "rule": "optional"
                  },
                  "brandOrderingUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locationToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cartToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cashCustomerToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CashLocalSource": {
                    "values": {
                      "DEFAULT_DO_NOT_USE": 0,
                      "SOURCE_WEB": 1,
                      "SOURCE_NATIVE": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.omg?.nested?.cash?.nested?.CashLocalOrderExtension && !$root.nested?.squareup?.nested?.omg?.nested?.cash?.nested?.CashLocalOrderExtension?.nested?.CashLocalSource) {
  $root.addJSON(jsonData);
}

/**
 * Information about the cash-app-local order that was used to place this order
 *
 * SOURCE CashLocalOrderExtension @ squareup/omg/cash/extensions.proto at 11:1
 */
export const CashLocalOrderExtension = $root.lookupType('squareup.omg.cash.CashLocalOrderExtension');
fixType(CashLocalOrderExtension);
Builder.createAndAttachToType(CashLocalOrderExtension);
/**
 * SOURCE CashLocalSource @ squareup/omg/cash/extensions.proto at 12:3
 */
CashLocalOrderExtension.CashLocalSource = $root.lookupEnum('squareup.omg.cash.CashLocalOrderExtension.CashLocalSource').values;